import { useState } from 'react';
import { useDemoCtx } from './DemoContext';

const NAV_ITEMS = ['프로필 설정', '보안', '알림 설정', '알림 이력', '사용자 관리', '권한 관리', '임계값 설정', 'API 연동', '데이터 관리'];
const USERS = [
    { initial: '김', name: '김관리자', email: 'admin@treemap.kr',   role: '관리자',    status: 'good',    badge: '활성',     gradient: 'linear-gradient(135deg,#1E8B53,#166840)' },
    { initial: '박', name: '박현장',   email: 'field@treemap.kr',   role: '현장관리자', status: 'good',    badge: '활성',     gradient: 'linear-gradient(135deg,#2563EB,#1d4ed8)' },
    { initial: '이', name: '이담당',   email: 'manager@treemap.kr', role: '관리자',    status: 'neutral', badge: '초대 대기', gradient: 'linear-gradient(135deg,#7C3AED,#6d28d9)' },
];

export default function DemoSettings() {
    const { toast } = useDemoCtx();
    const [activeNav, setActiveNav] = useState(0);
    const [notifChannels, setNotifChannels] = useState([true, true, false]);
    const [rangeVals, setRangeVals] = useState([35, 90, 6]);
    const [autoAlert, setAutoAlert] = useState(true);

    const toggleNotif = (i: number) => setNotifChannels(p => p.map((v, idx) => idx === i ? !v : v));
    const NOTIF = [{ ico: '🔔', lbl: '인앱 알림' }, { ico: '💬', lbl: '카카오톡' }, { ico: '✉️', lbl: '이메일' }];

    return (
        <div style={{ height: '100%', overflow: 'hidden' }}>
            <div className="settings-wrap">
                {/* Left nav */}
                <div className="settings-nav">
                    <div className="sb-section-lbl" style={{ fontSize: 10, padding: '8px 4px 4px' }}>계정</div>
                    {NAV_ITEMS.slice(0, 2).map((n, i) => <div key={i} className={`settings-nav-item${activeNav === i ? ' active' : ''}`} onClick={() => setActiveNav(i)}>{n}</div>)}
                    <div className="sb-section-lbl" style={{ fontSize: 10, padding: '8px 4px 4px' }}>알림</div>
                    {NAV_ITEMS.slice(2, 4).map((n, i) => <div key={i + 2} className={`settings-nav-item${activeNav === i + 2 ? ' active' : ''}`} onClick={() => setActiveNav(i + 2)}>{n}</div>)}
                    <div className="sb-section-lbl" style={{ fontSize: 10, padding: '8px 4px 4px' }}>조직</div>
                    {NAV_ITEMS.slice(4, 6).map((n, i) => <div key={i + 4} className={`settings-nav-item${activeNav === i + 4 ? ' active' : ''}`} onClick={() => setActiveNav(i + 4)}>{n}</div>)}
                    <div className="sb-section-lbl" style={{ fontSize: 10, padding: '8px 4px 4px' }}>시스템</div>
                    {NAV_ITEMS.slice(6).map((n, i) => <div key={i + 6} className={`settings-nav-item${activeNav === i + 6 ? ' active' : ''}`} onClick={() => setActiveNav(i + 6)}>{n}</div>)}
                </div>

                {/* Body */}
                <div className="settings-body">
                    <div className="settings-section">
                        <div className="settings-section-ttl">프로필 설정</div>
                        <div className="settings-section-desc">계정 정보 및 개인 설정을 관리합니다</div>

                        {/* 기본 정보 */}
                        <div className="settings-block">
                            <div className="settings-block-ttl">기본 정보</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 18 }}>
                                <div style={{ width: 58, height: 58, borderRadius: 14, background: 'linear-gradient(135deg,#1E8B53,#166840)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 800, color: '#fff' }}>김</div>
                                <button className="btn btn-secondary btn-sm" onClick={() => toast('이미지 업로드', 'success')}>프로필 사진 변경</button>
                            </div>
                            <div className="form-row" style={{ marginBottom: 13 }}>
                                <div className="form-group"><label className="form-label">이름</label><input className="form-input" defaultValue="김관리자" /></div>
                                <div className="form-group"><label className="form-label">직책</label><select className="form-select"><option selected>관리자</option><option>팀장</option><option>현장관리자</option></select></div>
                            </div>
                            <div className="form-group" style={{ marginBottom: 14 }}><label className="form-label">이메일</label><input className="form-input" defaultValue="admin@treemap.kr" /></div>
                            <button className="btn btn-primary btn-sm" onClick={() => toast('저장 완료', 'success')}>변경사항 저장</button>
                        </div>

                        {/* 알림 채널 */}
                        <div className="settings-block">
                            <div className="settings-block-ttl">알림 채널</div>
                            <div className="notif-ch-grid">
                                {NOTIF.map((n, i) => (
                                    <div key={i} className={`notif-ch-card${notifChannels[i] ? ' active' : ''}`} onClick={() => toggleNotif(i)}>
                                        <div className="notif-ch-ico">{n.ico}</div>
                                        <div className="notif-ch-lbl">{n.lbl}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* 임계값 */}
                        <div className="settings-block">
                            <div className="settings-block-ttl">임계값 설정 (전체 단지 기본값)</div>
                            {[
                                { lbl: '수분율 하한 경보', desc: '이 수치 이하면 위험 알림 발송', min: 10, max: 60,  idx: 0 },
                                { lbl: '수분율 상한 경보', desc: '이 수치 이상이면 과습 알림 발송', min: 60, max: 100, idx: 1 },
                                { lbl: '건조 스트레스 경보', desc: '스트레스 지수 기준값 (1~10)', min: 1,  max: 10,  idx: 2 },
                            ].map(r => (
                                <div key={r.idx} className="settings-row">
                                    <div>
                                        <div className="settings-row-lbl">{r.lbl}</div>
                                        <div className="settings-row-desc">{r.desc}</div>
                                    </div>
                                    <div className="range-row">
                                        <input type="range" className="range-sl" min={r.min} max={r.max} value={rangeVals[r.idx]}
                                            onChange={e => setRangeVals(p => p.map((v, i) => i === r.idx ? Number(e.target.value) : v))} />
                                        <span className="range-val">{rangeVals[r.idx]}{r.idx < 2 ? '%' : ''}</span>
                                    </div>
                                </div>
                            ))}
                            <div className="settings-row" style={{ borderBottom: 'none' }}>
                                <div>
                                    <div className="settings-row-lbl">자동 알림 활성화</div>
                                    <div className="settings-row-desc">임계값 초과 시 자동 알림 발송</div>
                                </div>
                                <label className="toggle">
                                    <input type="checkbox" checked={autoAlert} onChange={e => setAutoAlert(e.target.checked)} />
                                    <span className="toggle-sl" />
                                </label>
                            </div>
                        </div>

                        {/* 사용자 관리 */}
                        <div className="settings-block">
                            <div className="settings-block-ttl">사용자 관리</div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                {USERS.map((u, i) => (
                                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, background: 'var(--surface2)', borderRadius: 10, border: '1.5px solid var(--border)' }}>
                                        <div className="user-avatar" style={{ background: u.gradient }}>{u.initial}</div>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: 13, fontWeight: 700 }}>{u.name}</div>
                                            <div className="text-xs text-muted">{u.email} · {u.role}</div>
                                        </div>
                                        <span className={`badge badge-${u.status}`}>{u.badge}</span>
                                        <button className="btn btn-ghost btn-sm">편집</button>
                                    </div>
                                ))}
                                <button className="btn btn-secondary btn-sm" style={{ alignSelf: 'flex-start' }} onClick={() => toast('사용자 초대 이메일 발송', 'success')}>＋ 사용자 초대</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
